import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import AddTransactionWizardModal from '../../components/transactions/AddTransactionWizardModal';

/**
 * Deep-link host for creating a transaction. Opens the add-transaction wizard and
 * returns to the transactions list when it closes. An optional ?project= query
 * param pre-selects the project on the first allocation.
 */
const AddTransactionPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { orgId } = useParams();
    const projectId = new URLSearchParams(location.search).get('project');

    const goToList = () => navigate(`/app/${orgId}/transactions`);

    return (
        <AddTransactionWizardModal
            open
            defaultProjectId={projectId}
            onClose={goToList}
            onSaved={goToList}
        />
    );
};

export default AddTransactionPage;
